/**
 *
 * SettingsInvoiceDetailDetectionsPage
 *
 */

import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'lib/intl';

// ui
import { Flex, Text } from '@domonda/ui';

// modules
import { InvoiceDetailDetectionsSettings } from 'modules/InvoiceDetail/InvoiceDetailDetections';

export type SettingsInvoiceDetailDetectionsPageProps = RouteComponentProps;

const SettingsInvoiceDetailDetectionsPage: React.FC<
  SettingsInvoiceDetailDetectionsPageProps
> = () => {
  return (
    <Flex container direction="column" spacing={1}>
      <Flex item>
        <Text variant="title">
          <FormattedMessage id="SETTINGS_DETECTIONS_ORDER" />
        </Text>
      </Flex>

      <Flex item>
        <InvoiceDetailDetectionsSettings />
      </Flex>
    </Flex>
  );
};

const ComposedSettingsInvoiceDetailDetectionsPage = SettingsInvoiceDetailDetectionsPage;
export { ComposedSettingsInvoiceDetailDetectionsPage as SettingsInvoiceDetailDetectionsPage };
